export default __webpack_public_path__ + "static/media/football-manager.3c4fe552.webp";